var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66C6FE"
    },
    d: "M41.514,87.173c-4.585,0-8.303,3.717-8.303,8.303v84.134h16.605V95.476 C49.816,90.89,46.099,87.173,41.514,87.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66C6FE"
    },
    d: "M74.724,87.173c-4.585,0-8.303,3.717-8.303,8.303v84.134l16.605-34.871V95.476 C83.027,90.89,79.31,87.173,74.724,87.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66C6FE"
    },
    d: "M8.303,87.173C3.717,87.173,0,90.89,0,95.476v49.263l16.605,34.871V95.476 C16.605,90.89,12.888,87.173,8.303,87.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66C6FE"
    },
    d: "M428.212,239.922l-42.243-96.47c-24.139-26.979-56.82-46.144-93.801-53.24 c0,0-0.053,331.041,0,331.566C370.095,406.825,428.973,338.289,428.973,256C428.973,250.577,428.716,245.206,428.212,239.922z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99D9FF"
    },
    d: "M362.012,143.452c-18.244-25.189-42.522-43.562-70.037-51.676l-63.841-1.553 c-23.603,4.523-45.459,13.966-64.452,27.226l-70.23,111.754c-1.404,8.726-2.122,17.676-2.122,26.797 c0,8.307,0.6,16.486,1.769,24.471l43.743,90.82c23.871,25.532,55.577,43.637,91.292,50.496c0-0.011,63.841-1.565,63.841-1.565 c60.133-17.718,104.841-84.529,104.841-164.223L362.012,143.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#668A30"
    },
    d: "M385.979,143.442c-0.011,0.011-23.967,0.011-23.967,0.011l34.804,112.548h15.317 c8.886,0,16.078-7.203,16.078-16.078C424.729,203.017,409.358,169.563,385.979,143.442z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCECFF"
    },
    d: "M291.975,420.223l-30.056,4.588c10.333-0.107,20.441-1.136,30.248-3.022 C292.115,421.253,292.061,420.738,291.975,420.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCECFF"
    },
    d: "M261.92,87.189l30.056,4.588c0.086-0.515,0.139-1.028,0.193-1.554 C282.361,88.325,272.253,87.297,261.92,87.189z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFDCA"
    },
    d: "M291.975,91.777c-2.218,15.575-15.628,27.558-31.824,27.558c-16.732,0-30.484-12.787-32.017-29.113 c10.365-2.005,21.073-3.044,32.017-3.044c0.59,0,1.179,0,1.769,0.011C272.253,87.35,282.317,88.936,291.975,91.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFDCA"
    },
    d: "M260.151,392.665c16.196,0,29.605,11.984,31.824,27.558c-9.658,2.841-19.723,4.427-30.056,4.588 c-0.59,0.011-1.179,0.011-1.769,0.011c-10.944,0-21.652-1.039-32.017-3.033C229.667,405.453,243.42,392.665,260.151,392.665z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84B044"
    },
    d: "M110.087,272.078c-6.903,0-13.026,3.278-16.947,8.346c-0.014,0.018-0.029,0.029-0.042,0.047 c5.059,34.868,20.773,66.274,43.743,90.82c0.001-0.001,23.933-29.069,23.933-29.069c7.495-9.102,13.626-26.197,13.626-37.988 v-32.157h-64.313V272.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84B044"
    },
    d: "M93.452,229.203h53.624v10.718c0,4.585,3.717,8.303,8.303,8.303c4.585,0,8.303-3.717,8.303-8.303 V117.449C126.895,143.099,100.805,183.026,93.452,229.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84B044"
    },
    d: "M335.182,220.899c-4.586,0-8.303,3.717-8.303,8.303v23.854h-74.531 c-13.456,0-24.355,10.899-24.355,24.355c0,13.456,10.899,24.355,24.355,24.355h7.802v39.985c0,11.791,9.647,21.438,21.438,21.438 h37.516v-93.526h16.077c4.586,0,8.303-3.717,8.303-8.303v-32.157C343.485,224.617,339.769,220.899,335.182,220.899z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#668A30"
    },
    d: "M351.262,348.252c-4.586,0-8.303-3.717-8.303-8.303v-11.07c0-4.585,3.716-8.303,8.303-8.303 s8.303,3.717,8.303,8.303v11.07C359.565,344.536,355.847,348.252,351.262,348.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#668A30"
    },
    d: "M238.714,173.368c-4.585,0-8.303-3.717-8.303-8.303v-11.07c0-4.585,3.717-8.303,8.303-8.303 c4.585,0,8.303,3.717,8.303,8.303v11.07C247.016,169.652,243.299,173.368,238.714,173.368z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84B044"
    },
    d: "M396.816,256c0-43.239-13.163-82.674-34.804-112.548h-58.986c-4.586,0-8.303,3.717-8.303,8.303 c0,4.585,3.716,8.303,8.303,8.303h16.077v18.802h-10.719c-8.875,0-16.078,7.203-16.078,16.078h-43.225v24.908h-10.367 c-4.585,0-8.303,3.717-8.303,8.303c0,4.585,3.717,8.303,8.303,8.303h120.323v46.346c0,4.585,3.716,8.303,8.303,8.303 s8.303-3.717,8.303-8.303V256H396.816z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#66C6FE"
    },
    points: "511.989,267.065 511.989,300.276 495.384,330.73 478.778,300.276 478.778,250.47 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99D9FF"
    },
    d: "M511.989,300.276v107.946c0,9.166-7.439,16.605-16.605,16.605c-9.166,0-16.605-7.439-16.605-16.605 V300.276H511.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99D9FF"
    },
    d: "M487.092,87.173c-13.757,0-24.908,11.152-24.908,24.908v130.076 c0,13.757,11.151,24.908,24.908,24.908H512c0-71.9,0-154.984,0-154.984C512,98.325,500.849,87.173,487.092,87.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#99D9FF"
    },
    d: "M0,144.738v18.271c0,17.022,10.249,31.642,24.908,38.05v207.151c0,9.171,7.435,16.605,16.605,16.605 s16.605-7.435,16.605-16.605V201.059c14.659-6.407,24.908-21.028,24.908-38.05v-18.271H0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.17f5e3da1a5d3c70fec09fe05dc4caac.svg";
export { ForwardRef as ReactComponent };